import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vModelText as _vModelText, vModelCheckbox as _vModelCheckbox, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-708029e1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-global" }
const _hoisted_2 = { class: "company-header flex items-center" }
const _hoisted_3 = { class: "page-title" }
const _hoisted_4 = { class: "grid grid-cols-1 gap-6 mt-6 lg:grid-cols-6" }
const _hoisted_5 = { class: "lg:col-span-2" }
const _hoisted_6 = { class: "mb-4" }
const _hoisted_7 = {
  class: "input-form-label",
  for: "company-visibility-filter"
}
const _hoisted_8 = { value: "" }
const _hoisted_9 = { value: "internal" }
const _hoisted_10 = { value: "external" }
const _hoisted_11 = { class: "company-tree" }
const _hoisted_12 = {
  key: 0,
  class: "py-8 text-center text-gray-500"
}
const _hoisted_13 = { class: "lg:col-span-4" }
const _hoisted_14 = { class: "block-title" }
const _hoisted_15 = {
  key: 0,
  class: "company-empty-state mt-6 text-gray-500"
}
const _hoisted_16 = { class: "card-global flex divide-x" }
const _hoisted_17 = { class: "flex-1 flex-col space-y-6" }
const _hoisted_18 = { class: "flex flex-col" }
const _hoisted_19 = ["placeholder"]
const _hoisted_20 = {
  key: 0,
  class: "input-form-error-text"
}
const _hoisted_21 = { class: "flex flex-col" }
const _hoisted_22 = { class: "flex flex-col" }
const _hoisted_23 = ["placeholder"]
const _hoisted_24 = { class: "flex space-x-12" }
const _hoisted_25 = { class: "flex flex-col" }
const _hoisted_26 = { class: "" }
const _hoisted_27 = ["disabled"]
const _hoisted_28 = {
  class: "pl-2",
  for: "checkbox-company"
}
const _hoisted_29 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_30 = ["placeholder", "disabled"]
const _hoisted_31 = {
  key: 0,
  class: "mt-1 text-sm text-gray-500"
}
const _hoisted_32 = {
  key: 1,
  class: "input-form-error-text"
}
const _hoisted_33 = {
  key: 1,
  class: "flex space-x-12"
}
const _hoisted_34 = { class: "flex flex-col" }
const _hoisted_35 = {
  key: 2,
  class: "flex flex-col space-y-2"
}
const _hoisted_36 = { class: "input-form-label" }
const _hoisted_37 = { class: "flex items-center gap-2" }
const _hoisted_38 = ["disabled"]
const _hoisted_39 = { class: "flex items-center gap-2" }
const _hoisted_40 = { class: "flex gap-3" }
const _hoisted_41 = {
  key: 2,
  class: "mt-6 p-4 rounded border border-gray-200 text-gray-500"
}
const _hoisted_42 = {
  key: 1,
  class: "company-empty-state"
}
const _hoisted_43 = { class: "mt-4 text-lg font-semibold text-gray-700" }
const _hoisted_44 = { class: "mt-2 max-w-md text-center text-gray-500" }
const _hoisted_45 = {
  key: 0,
  class: "mt-1 max-w-md text-center text-gray-500"
}

import BackButton from "@/components/common/BackButton.vue";
import { ref, onMounted, computed, reactive, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import { useToast } from "vue-toastification";
import DeactivateEntityModal from "@/components/common/DeactivateEntityModal.vue";
import EntityScopeFields from "@/components/common/EntityScopeFields.vue";
import {
  defaultScopeFields,
  withScopeFields,
  scopeFromEntity,
} from "@/utils/entityScope";
import { IScopeFields } from "@/types/common/entityApproval/EntityScope";
import { CompanyGetters } from "@/store/modules/company/getters";
import { CompanyActions } from "@/store/modules/company/actions";
import { Company } from "@/types";
import { StatusesEnum } from "@/store";
import { numeric, required } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import { CompanyDataService } from "@/services";
import { CompanyTypesEnum } from "@/store/modules/company/state";
import Multiselect from "@vueform/multiselect";
import TreeListMulti from "@/components/common/TreeListMulti.vue";
import { AuthGetters } from "@/store/modules/auth";
import { OfficeBuildingIcon, PlusIcon } from "@heroicons/vue/outline";
import { t } from "@/i18n";
import { getCommonStatusOptions, getCompanyTypeOptions } from "@/utils/labels";

type ValidationErrorResponse = {
  data?: {
    data?: Record<string, unknown>;
  };
};


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const currentCompany = ref(0);
const formMode = ref<"idle" | "create" | "edit">("idle");
const deactivateModalShow = ref(false);
const isCompanyLoading = ref(false);
const isSubmitting = ref(false);
const isInitialized = ref(false);
const scopeFields = ref<IScopeFields>(defaultScopeFields());
const authEnabled = ref(true);
const externalSigning = ref(false);
const companyVisibilityFilter = ref("");

const route = useRoute();
const router = useRouter();
const store = useStore();
const toast = useToast();
const currentUser = computed(
  () => store.getters[AuthGetters.GET_USER_IDENTITY]
);
const statuses = computed(() => getCommonStatusOptions());
const companyTypes = computed(() => getCompanyTypeOptions());
const permissions = computed<string[]>(() =>
  Array.isArray(currentUser.value?.permissions)
    ? currentUser.value.permissions
    : []
);
const canCreateCompany = computed(() =>
  permissions.value.includes("COMPANY_CREATE")
);
const canEditCompany = computed(() =>
  permissions.value.includes("COMPANY_EDIT")
);
const canDeactivateCompany = computed(() =>
  permissions.value.includes("COMPANY_DEACTIVATE")
);
const canManageCurrentForm = computed(() =>
  formMode.value === "create" ? canCreateCompany.value : canEditCompany.value
);
const isRootCompanyEdit = computed(
  () => formMode.value === "edit" && state.parentId == null
);
const formTitle = computed(() =>
  formMode.value === "edit" ? t("company.titleEdit") : t("company.titleCreate")
);

onMounted(async () => {
  await Promise.all([reloadCompanies(), reloadParentCompanies()]);
  isInitialized.value = true;
  await applyRouteState();
});

watch(
  () => [route.name, route.params.id],
  () => {
    if (isInitialized.value) {
      return applyRouteState();
    }
  }
);

const reloadCompanies = async () => {
  await store.dispatch(CompanyActions.FETCH_DATA_PROVIDER);
};

const reloadParentCompanies = async () => {
  try {
    const response = await CompanyDataService.getParents();
    parentCompanies.value = response.data.data ?? [];
  } catch {
    parentCompanies.value = [];
    toast.error(t("company.parentLoadError"));
  }
};

const dataProvider = computed(
  () => store.getters[CompanyGetters.GET_DATA_PROVIDER] ?? []
);

const getParentId = (company: Company): string | null | undefined =>
  company.parent !== undefined ? company.parent : company.parentId;

const getRootCompanyId = (
  company: Company,
  companiesById: Map<string, Company>
): string | undefined => {
  let current: Company | undefined = company;
  let parentId = current ? getParentId(current) : null;
  const visitedIds = new Set<string>();
  while (current && parentId != null) {
    if (visitedIds.has(parentId)) {
      return undefined;
    }
    visitedIds.add(parentId);
    current = companiesById.get(parentId);
    parentId = current ? getParentId(current) : null;
  }
  return current?.id;
};

const filteredDataProvider = computed(() => {
  const companies: Company[] = dataProvider.value;
  if (!companyVisibilityFilter.value) {
    return companies;
  }

  const companiesById = new Map<string, Company>();
  companies.forEach((company: Company) => {
    if (company.id != null) {
      companiesById.set(company.id, company);
    }
  });

  const internalRootIds = new Set(
    companies
      .filter(
        (company: Company) =>
          getParentId(company) == null && company.authEnabled === true
      )
      .map((company: Company) => company.id)
      .filter((id): id is string => id != null)
  );

  const externalRootIds = new Set(
    companies
      .filter(
        (company: Company) =>
          getParentId(company) == null && company.authEnabled === false
      )
      .map((company: Company) => company.id)
      .filter((id): id is string => id != null)
  );

  const allowedRootIds =
    companyVisibilityFilter.value === "internal"
      ? internalRootIds
      : externalRootIds;

  return companies.filter((company: Company) => {
    const rootId = getRootCompanyId(company, companiesById);
    return rootId != null && allowedRootIds.has(rootId);
  });
});

const directorateOptions = computed(() => {
  const items = dataProvider.value ?? [];
  return items.flatMap((company: Company) =>
    company.id == null ? [] : [{ id: company.id, name: company.name }]
  );
});

async function handleTreeListSelect(data: Company) {
  if (!data.id) {
    return;
  }

  if (route.name === "CompanyEdit" && String(route.params.id) === data.id) {
    await loadCompany(data.id);
    return;
  }

  await router.push({ name: "CompanyEdit", params: { id: data.id } });
}

let companyRequestSequence = 0;

async function loadCompany(id: string) {
  const requestSequence = ++companyRequestSequence;
  currentCompany.value = id;
  formMode.value = "edit";
  submitted.value = false;
  $externalResults.value = {};

  if (!canEditCompany.value) {
    isCompanyLoading.value = false;
    return;
  }

  isCompanyLoading.value = true;
  try {
    const response = await CompanyDataService.get(id);
    if (requestSequence !== companyRequestSequence) {
      return;
    }
    const company = response.data.data as Company;
    populateCompanyState(company);
  } catch {
    if (requestSequence !== companyRequestSequence) {
      return;
    }
    toast.error(t("company.loadError"));
    await router.replace({ name: "CompanyList" });
  } finally {
    if (requestSequence === companyRequestSequence) {
      isCompanyLoading.value = false;
    }
  }
}

function populateCompanyState(company: Company) {
  state.id = company.id;
  state.status = company.status;
  state.name = company.name;
  state.index = company.index;
  state.parentId = getParentId(company) ?? null;
  state.position = company.position;
  state.isCompany = company.isCompany;
  state.personType = company.personType;
  state.bin = company.bin;
  authEnabled.value = company.authEnabled !== false;
  externalSigning.value = company.authEnabled === false;
  scopeFields.value = scopeFromEntity(company);
}

const state = reactive<Company>({
  status: StatusesEnum.ACTIVE,
  name: "",
  index: "",
  parentId: null,
  position: 1,
  isCompany: false,
  personType: CompanyTypesEnum.LEGAL,
  bin: "",
});
const rules = {
  status: { required },
  name: { required },
  index: { required },
  parentId: {},
  position: { required },
  isCompany: {},
  personType: { required },
  bin: { numeric },
};
const $externalResults = ref({});
const submitted = ref(false);
const v$ = useVuelidate(rules, state, { $externalResults });

const parentCompanies = ref<Company[]>([]);

async function handleSubmit(isFormValid: boolean) {
  if (isSubmitting.value) {
    return;
  }

  submitted.value = true;
  if (!isFormValid) {
    return;
  }

  isSubmitting.value = true;
  const submittedMode = formMode.value;
  try {
    const success =
      submittedMode === "edit" ? await updateCompany() : await createCompany();
    if (success) {
      await Promise.all([reloadCompanies(), reloadParentCompanies()]);
    }
  } finally {
    isSubmitting.value = false;
  }
}

const buildCompanyPayload = () => {
  const base = {
    ...state,
    authEnabled: state.isCompany
      ? externalSigning.value
        ? false
        : authEnabled.value
      : false,
  };
  return withScopeFields(base, scopeFields.value);
};

const validationErrorsFrom = (error: unknown): Record<string, unknown> =>
  (error as ValidationErrorResponse)?.data?.data ?? {};

const createCompany = async (): Promise<boolean> => {
  try {
    await store.dispatch(CompanyActions.CREATE, buildCompanyPayload());
    toast.success(t("approval.submitted"));
    await closeForm();
    return true;
  } catch (error: unknown) {
    $externalResults.value = validationErrorsFrom(error);
    toast.error(t("approval.submitError"));
    return false;
  }
};

const updateCompany = async (): Promise<boolean> => {
  try {
    await store.dispatch(CompanyActions.UPDATE, {
      id: state.id,
      data: buildCompanyPayload(),
    });
    toast.success(t("approval.submitted"));
    return true;
  } catch (error: unknown) {
    $externalResults.value = validationErrorsFrom(error);
    toast.error(t("approval.submitError"));
    return false;
  }
};

const confirmDeactivate = async (coordinatorId?: string) => {
  if (!currentCompany.value) {
    return;
  }
  try {
    await store.dispatch(CompanyActions.DELETE, {
      id: currentCompany.value,
      coordinatorId,
    });
    toast.success(t("approval.submitted"));
    deactivateModalShow.value = false;
    await closeForm();
    await reloadCompanies();
  } catch {
    toast.error(t("deactivate.error"));
  }
};

function resetFormState() {
  submitted.value = false;
  $externalResults.value = {};
  v$.$reset();
  state.id = undefined;
  state.status = StatusesEnum.ACTIVE;
  state.name = "";
  state.index = "";
  state.parentId = null;
  state.position = 1;
  state.isCompany = false;
  state.personType = CompanyTypesEnum.LEGAL;
  state.bin = "";
  authEnabled.value = true;
  externalSigning.value = false;
  scopeFields.value = defaultScopeFields();
}

function setCreateFormState() {
  companyRequestSequence += 1;
  isCompanyLoading.value = false;
  currentCompany.value = 0;
  formMode.value = "create";
  resetFormState();
}

function setIdleState() {
  companyRequestSequence += 1;
  isCompanyLoading.value = false;
  currentCompany.value = 0;
  formMode.value = "idle";
  resetFormState();
}

async function openCreateForm() {
  setCreateFormState();
  if (route.name !== "CompanyCreate") {
    await router.push({ name: "CompanyCreate" });
  }
}

async function closeForm() {
  setIdleState();
  if (route.name !== "CompanyList") {
    await router.push({ name: "CompanyList" });
  }
}

async function applyRouteState() {
  if (route.name === "CompanyCreate") {
    setCreateFormState();
    return;
  }

  if (route.name === "CompanyEdit") {
    const companyId = String(route.params.id);
    if (Number.isInteger(companyId) && companyId > 0) {
      await loadCompany(companyId);
      return;
    }
    await router.replace({ name: "CompanyList" });
    return;
  }

  if (route.name === "CompanyList") {
    setIdleState();
  }
}

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_SegmentedButtons = _resolveComponent("SegmentedButtons")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.$route.name === 'CompanyCreate' || _ctx.$route.name === 'CompanyEdit')
      ? (_openBlock(), _createBlock(BackButton, {
          key: 0,
          to: { name: 'CompanyList' },
          class: "mb-4"
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h1", _hoisted_3, _toDisplayString(_unref(t)("companyList.title")), 1),
        (_unref(canCreateCompany))
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              class: "flex px-10 float-right ml-auto",
              onClick: _withModifiers(openCreateForm, ["prevent"])
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(PlusIcon), { class: "button-icon mr-2" }),
                _createTextVNode(" " + _toDisplayString(_unref(t)("company.submitCreate")), 1)
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("label", _hoisted_7, _toDisplayString(_unref(t)("company.filter.label")), 1),
            _withDirectives(_createElementVNode("select", {
              id: "company-visibility-filter",
              class: "input-form w-full",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((companyVisibilityFilter).value = $event))
            }, [
              _createElementVNode("option", _hoisted_8, _toDisplayString(_unref(t)("company.filter.all")), 1),
              _createElementVNode("option", _hoisted_9, _toDisplayString(_unref(t)("company.filter.internal")), 1),
              _createElementVNode("option", _hoisted_10, _toDisplayString(_unref(t)("company.filter.external")), 1)
            ], 512), [
              [_vModelSelect, companyVisibilityFilter.value]
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(TreeListMulti, {
              items: _unref(filteredDataProvider),
              "active-id": currentCompany.value,
              onSelect: _cache[1] || (_cache[1] = ($event: any) => (handleTreeListSelect($event)))
            }, null, 8, ["items", "active-id"]),
            (_unref(filteredDataProvider).length === 0)
              ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(_unref(t)("common.noData")), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          (formMode.value !== 'idle')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("h2", _hoisted_14, _toDisplayString(_unref(formTitle)), 1),
                (isCompanyLoading.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_unref(t)("company.loading")), 1))
                  : (_unref(canManageCurrentForm))
                    ? (_openBlock(), _createElementBlock("form", {
                        key: 1,
                        class: "mt-6",
                        onSubmit: _cache[14] || (_cache[14] = _withModifiers(($event: any) => (handleSubmit(!_unref(v$).$invalid)), ["prevent"]))
                      }, [
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("div", _hoisted_18, [
                              _createElementVNode("label", {
                                class: _normalizeClass(["input-form-label", { 'p-error': _unref(v$).name.$invalid && submitted.value }])
                              }, _toDisplayString(_unref(t)("company.name")), 3),
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: _normalizeClass(["input-form", {
                      'p-invalid': _unref(v$).name.$invalid && submitted.value,
                    }]),
                                placeholder: _unref(t)('company.namePlaceholder'),
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(v$).name.$model) = $event))
                              }, null, 10, _hoisted_19), [
                                [_vModelText, _unref(v$).name.$model]
                              ]),
                              (_unref(v$).name.$externalResults.length)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString(_unref(v$).name.$externalResults[0].$message), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_21, [
                              _createElementVNode("label", {
                                class: _normalizeClass(["input-form-label", { 'p-error': _unref(v$).parentId.$invalid && submitted.value }])
                              }, _toDisplayString(_unref(t)("company.parent")), 3),
                              _createVNode(_unref(Multiselect), {
                                modelValue: _unref(v$).parentId.$model,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(v$).parentId.$model) = $event)),
                                options: parentCompanies.value,
                                disabled: _unref(isRootCompanyEdit),
                                valueProp: "id",
                                "track-by": "name",
                                label: "name"
                              }, null, 8, ["modelValue", "options", "disabled"])
                            ]),
                            _createElementVNode("div", _hoisted_22, [
                              _createElementVNode("label", {
                                class: _normalizeClass(["input-form-label", { 'p-error': _unref(v$).index.$invalid && submitted.value }])
                              }, _toDisplayString(_unref(t)("company.index")), 3),
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: _normalizeClass(["input-form", {
                      'p-invalid': _unref(v$).index.$invalid && submitted.value,
                    }]),
                                placeholder: _unref(t)('company.indexPlaceholder'),
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(v$).index.$model) = $event))
                              }, null, 10, _hoisted_23), [
                                [_vModelText, _unref(v$).index.$model]
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_24, [
                              _createElementVNode("div", _hoisted_25, [
                                _createElementVNode("label", {
                                  class: _normalizeClass(["input-form-label", { 'p-error': _unref(v$).status.$invalid && submitted.value }])
                                }, _toDisplayString(_unref(t)("company.status")), 3),
                                _createVNode(_component_SegmentedButtons, {
                                  class: "",
                                  options: _unref(statuses),
                                  disabled: _unref(isRootCompanyEdit),
                                  modelValue: _unref(v$).status.$model,
                                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(v$).status.$model) = $event)),
                                  required: ""
                                }, null, 8, ["options", "disabled", "modelValue"])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_26, [
                              _withDirectives(_createElementVNode("input", {
                                type: "checkbox",
                                id: "checkbox-company",
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(v$).isCompany.$model) = $event)),
                                disabled: _unref(isRootCompanyEdit)
                              }, null, 8, _hoisted_27), [
                                [_vModelCheckbox, _unref(v$).isCompany.$model]
                              ]),
                              _createElementVNode("label", _hoisted_28, _toDisplayString(_unref(t)("company.isCompany")), 1)
                            ]),
                            (_unref(v$).isCompany.$model)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                  _createElementVNode("label", {
                                    class: _normalizeClass(["input-form-label", { 'p-error': _unref(v$).bin.$invalid && submitted.value }])
                                  }, _toDisplayString(_unref(t)("company.bin")), 3),
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: _normalizeClass(["input-form", {
                      'p-invalid': _unref(v$).bin.$invalid && submitted.value,
                    }]),
                                    placeholder: _unref(t)('company.binPlaceholder'),
                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(v$).bin.$model) = $event)),
                                    disabled: _unref(isRootCompanyEdit)
                                  }, null, 10, _hoisted_30), [
                                    [_vModelText, _unref(v$).bin.$model]
                                  ]),
                                  (_unref(isRootCompanyEdit))
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_31, _toDisplayString(_unref(t)("company.rootBinPlatformOnly")), 1))
                                    : _createCommentVNode("", true),
                                  (_unref(v$).bin.$externalResults.length)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_32, _toDisplayString(_unref(v$).bin.$externalResults[0].$message), 1))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true),
                            (_unref(v$).isCompany.$model)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                  _createElementVNode("div", _hoisted_34, [
                                    _createElementVNode("label", {
                                      class: _normalizeClass(["input-form-label", {
                        'p-error': _unref(v$).personType.$invalid && submitted.value,
                      }])
                                    }, _toDisplayString(_unref(t)("company.type")), 3),
                                    _createVNode(_component_SegmentedButtons, {
                                      class: "",
                                      options: _unref(companyTypes),
                                      modelValue: _unref(v$).personType.$model,
                                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(v$).personType.$model) = $event)),
                                      required: ""
                                    }, null, 8, ["options", "modelValue"])
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (_unref(v$).isCompany.$model)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                  _createElementVNode("label", _hoisted_36, _toDisplayString(_unref(t)("company.accessMode")), 1),
                                  _createElementVNode("label", _hoisted_37, [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "checkbox",
                                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((authEnabled).value = $event)),
                                      disabled: externalSigning.value
                                    }, null, 8, _hoisted_38), [
                                      [_vModelCheckbox, authEnabled.value]
                                    ]),
                                    _createElementVNode("span", null, _toDisplayString(_unref(t)("company.authEnabled")), 1)
                                  ]),
                                  _createElementVNode("label", _hoisted_39, [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "checkbox",
                                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((externalSigning).value = $event)),
                                      onChange: _cache[11] || (_cache[11] = ($event: any) => (externalSigning.value && (authEnabled.value = false)))
                                    }, null, 544), [
                                      [_vModelCheckbox, externalSigning.value]
                                    ]),
                                    _createElementVNode("span", null, _toDisplayString(_unref(t)("company.externalSigning")), 1)
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            _createVNode(EntityScopeFields, {
                              modelValue: scopeFields.value,
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((scopeFields).value = $event)),
                              "directorate-options": _unref(directorateOptions)
                            }, null, 8, ["modelValue", "directorate-options"]),
                            _createElementVNode("div", _hoisted_40, [
                              _createVNode(_component_Button, {
                                type: "submit",
                                disabled: isSubmitting.value
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(formMode.value === "edit"
                        ? _unref(t)("company.submitUpdate")
                        : _unref(t)("company.submitCreate")), 1)
                                ]),
                                _: 1
                              }, 8, ["disabled"]),
                              _createVNode(_component_Button, {
                                type: "button",
                                variant: "default",
                                onClick: closeForm
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(t)("common.cancel")), 1)
                                ]),
                                _: 1
                              }),
                              (
                      formMode.value === 'edit' &&
                      _unref(canDeactivateCompany) &&
                      !_unref(isRootCompanyEdit)
                    )
                                ? (_openBlock(), _createBlock(_component_Button, {
                                    key: 0,
                                    type: "button",
                                    variant: "danger",
                                    onClick: _cache[13] || (_cache[13] = ($event: any) => (deactivateModalShow.value = true))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_unref(t)("userDetails.delete")), 1)
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ])
                      ], 32))
                    : (_openBlock(), _createElementBlock("div", _hoisted_41, _toDisplayString(_unref(t)("common.noAccessToEdit")), 1))
              ], 64))
            : (_openBlock(), _createElementBlock("div", _hoisted_42, [
                _createVNode(_unref(OfficeBuildingIcon), { class: "h-12 w-12 text-gray-400" }),
                _createElementVNode("h2", _hoisted_43, _toDisplayString(_unref(t)("company.empty.title")), 1),
                _createElementVNode("p", _hoisted_44, _toDisplayString(_unref(t)("company.empty.description")), 1),
                (_unref(canCreateCompany))
                  ? (_openBlock(), _createElementBlock("p", _hoisted_45, _toDisplayString(_unref(t)("company.empty.createHint")), 1))
                  : _createCommentVNode("", true)
              ]))
        ])
      ])
    ]),
    _createVNode(DeactivateEntityModal, {
      show: deactivateModalShow.value,
      onHide: _cache[15] || (_cache[15] = ($event: any) => (deactivateModalShow.value = false)),
      onConfirm: confirmDeactivate
    }, null, 8, ["show"])
  ], 64))
}
}

})